import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const PreviewBody = styled(Typography, {
  name: 'PreviewBody',
  slot: 'Root',
  skipSx: true,
})(
  `
    font-family: 'Source Sans Pro';
    font-size: '14px';
`,
)
